import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Empty, Spin, Card, Tag, Progress, ConfigProvider } from "antd";

import Widget from "@/components/ui/Widget";

import { UserContext } from "@/context/UserContext";
import { getAllStatistics } from "@/api/widgets";

import { STATUS_OPTIONS, STATUS_COLORS } from "@/constants/tasks";

const getIcon = (color) => {
  return STATUS_OPTIONS.find((item) => item.value === color)?.icon;
};

const AllStatisticsWidget = ({ type_filter }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [mainStat, setMainStat] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    fetchData();

    // eslint-disable-next-line
  }, [type_filter]);

  const fetchData = async () => {
    setPending(true);

    try {
      const { data, total } = await getAllStatistics({ type_filter });

      const maxCountItem = data.reduce(
        (max, current) =>
          Number(current.count) > Number(max.count) ? current : max,
        data[0],
      );

      setMainStat(maxCountItem);

      setData(data);
      setTotal(total);
    } catch (error) {
      console.log("error", error);
    } finally {
      setPending(false);
    }
  };

  return (
    <Widget
      value="all_statistics"
      label="Все задачи"
      labelSecond={total}
      isOpen={true}
    >
      {pending ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        <>
          {!total ? (
            <Empty
              image={false}
              description="Нет задач"
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          ) : (
            <Flex vertical gap={8}>
              <Card>
                <Flex vertical gap={16}>
                  <Flex vertical gap={4}>
                    <div>
                      Большая часть задач со статусом "{mainStat?.name}"
                    </div>
                    <div className="progress-bar">
                      <div className="progress-segments">
                        {data.map((item) => (
                          <div
                            key={item.status_uuid}
                            className={`progress-segment`}
                            style={{
                              width: `${(item.count / total) * 100}%`,
                              backgroundColor:
                                STATUS_COLORS[item.color]?.progress,
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </Flex>
                  <Flex vertical gap={16}>
                    {data.map((item) => (
                      <Flex
                        vertical
                        gap={4}
                        key={item.status_uuid}
                        onClick={() =>
                          navigate(
                            `/tasks/t-list?status=${item.status_uuid}${
                              type_filter
                                ? `&executor=${user?.employee_uuid}`
                                : ""
                            }`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <Flex justify="space-between">
                          <Tag
                            icon={getIcon(item.color)}
                            color={item.color}
                            className="tag-with-icon-color"
                          >
                            {item.name}
                          </Tag>

                          <Tag
                            color={item.color}
                            style={{ margin: 0, fontWeight: 700 }}
                            className="tag-with-icon-color"
                          >
                            {item.count}/{total}
                          </Tag>
                        </Flex>
                        <ConfigProvider
                          theme={{
                            components: {
                              Progress: {
                                lineBorderRadius: 4,
                              },
                            },
                          }}
                        >
                          <Progress
                            percent={(item.count / total) * 100}
                            showInfo={false}
                            strokeColor={STATUS_COLORS[item.color]?.progress}
                            size={["100%", 22]}
                          />
                        </ConfigProvider>
                      </Flex>
                    ))}
                  </Flex>
                </Flex>
              </Card>
            </Flex>
          )}
        </>
      )}
    </Widget>
  );
};

export default AllStatisticsWidget;
